var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        placeholder: "请选择",
        loading: _vm.loading,
        clearable: "",
        disabled: _vm.disabled,
        filterable: "",
      },
      on: { change: _vm.handleChange },
      model: {
        value: _vm.selectedValue,
        callback: function ($$v) {
          _vm.selectedValue = $$v
        },
        expression: "selectedValue",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.Value,
        attrs: { label: item.Name, value: item.Value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }